module.exports = __webpack_public_path__ + "img/1440.28108c52.jpg";